import { render } from "./SuperAdminCreator.vue?vue&type=template&id=6c4324c2"
import script from "./SuperAdminCreator.vue?vue&type=script&lang=js"
export * from "./SuperAdminCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__